export var componentIds = function componentIds() {
  var except = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var filters = ['poliza_ramo', 'poliza_renewal_status_name', 'poliza_tipo_de_pago', 'poliza_company_name', 'poliza_nombre_contratante', 'poliza_nombre_asegurado', 'poliza_id', 'poliza_finish_date', 'created_at', 'updated_at', 'condition', 'prima_neta_range', 'materia_asegurada'];

  if (except === null) {
    return filters;
  }

  return filters.filter(function (filter) {
    return filter !== except;
  });
};